import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';
import classnames from 'classnames';

export interface Props extends NavLinkProps {
  underlined?: boolean;
  color?: 'orange' | 'blue' | 'red';
}

const colorClasses = {
  orange: 'text-orange visited:text-orange',
  blue: 'text-blue visited:text-blue',
  red: 'text-red visited:text-red'
};

const Link: React.FC<Props> = ({ underlined, color, className, children, ...rest }) => (
  <NavLink
    className={classnames(
      'cursor-pointer no-underline text-black visited:text-inherit',
      underlined && 'underline',
      color && colorClasses[color],
      className
    )}
    {...rest}
  >
    {children}
  </NavLink>
);

export default Link;
